
(function () {
  'use strict';

  var ADRES_INDEKSU = '/collections/all?section_id=bramowe-home-search-index';
  var KLUCZ_PAMIECI = 'bramowe-home-index-v2';
  var MIN_DLUGOSC_KODU = 4;
  var MIN_CYFR_KODU = 3;
  var MIN_CYFR_W_TYTULE = 4;

  var POLSKIE = {
    'Ą': 'A', 'Ć': 'C', 'Ę': 'E', 'Ł': 'L', 'Ń': 'N',
    'Ó': 'O', 'Ś': 'S', 'Ź': 'Z', 'Ż': 'Z'
  };

  function normalize(wartosc) {
    if (wartosc === null || wartosc === undefined) return '';
    var s = String(wartosc).toUpperCase();
    s = s.replace(/[ĄĆĘŁŃÓŚŹŻ]/g, function (z) { return POLSKIE[z]; });
    s = s.replace(/[\s \-‐‑‒–—._/\\]/g, '');
    return s;
  }

  function kodIdealny(wartosc) {
    var kod = normalize(wartosc);
    if (/^0\d{12}$/.test(kod)) kod = kod.slice(1);
    return kod;
  }

  function liczCyfry(tekst) {
    var trafienia = String(tekst).match(/\d/g);
    return trafienia ? trafienia.length : 0;
  }

  function isCodeQuery(zapytanie) {
    if (!zapytanie) return false;
    var tokeny = String(zapytanie).trim().split(/[\s ]+/);
    for (var i = 0; i < tokeny.length; i += 1) {
      var token = tokeny[i];
      if (token.length >= MIN_DLUGOSC_KODU && liczCyfry(token) >= MIN_CYFR_KODU) return true;
    }
    return false;
  }

  function tokenyZTytulu(tytul) {
    var wynik = [];
    var tokeny = String(tytul || '').split(/[\s ]+/);
    for (var i = 0; i < tokeny.length; i += 1) {
      if (liczCyfry(tokeny[i]) >= MIN_CYFR_W_TYTULE) {
        var znormalizowany = normalize(tokeny[i]);
        if (znormalizowany) wynik.push(znormalizowany);
      }
    }
    return wynik;
  }

  function kluczDnia() {
    return KLUCZ_PAMIECI + '-' + new Date().toISOString().slice(0, 10);
  }

  function zPamieci() {
    try {
      var surowe = window.sessionStorage.getItem(kluczDnia());
      return surowe ? JSON.parse(surowe) : null;
    } catch (e) {
      return null;
    }
  }

  function doPamieci(rekordy) {
    try {
      window.sessionStorage.setItem(kluczDnia(), JSON.stringify(rekordy));
    } catch (e) {
    }
  }

  function pobierzStrone(numer) {
    return fetch(ADRES_INDEKSU + '&page=' + numer, { headers: { Accept: 'text/html' } })
      .then(function (odpowiedz) {
        if (!odpowiedz.ok) throw new Error('indeks: HTTP ' + odpowiedz.status);
        return odpowiedz.text();
      })
      .then(function (html) {
        var szkielet = document.implementation.createHTMLDocument('');
        szkielet.body.innerHTML = html;
        var wezel = szkielet.querySelector('[data-bramowe-home-search-index]');
        if (!wezel) throw new Error('indeks: brak danych na stronie ' + numer);
        return JSON.parse(wezel.textContent);
      });
  }

  var stanIndeksu = null;

  function zbudujMape(rekordy) {
    var mapa = Object.create(null);
    for (var i = 0; i < rekordy.length; i += 1) {
      var rekord = rekordy[i];
      var kody = (rekord.c || []).map(normalize).concat(tokenyZTytulu(rekord.t));
      for (var k = 0; k < kody.length; k += 1) {
        var kod = kody[k];
        if (!kod) continue;
        if (!mapa[kod]) mapa[kod] = [];
        if (mapa[kod].indexOf(rekord) === -1) mapa[kod].push(rekord);
      }
      rekord.k = kody;
    }
    return mapa;
  }

  function zbudujMapeIdealna(rekordy) {
    var mapa = Object.create(null);
    for (var i = 0; i < rekordy.length; i += 1) {
      var warianty = rekordy[i].v || [];
      for (var w = 0; w < warianty.length; w += 1) {
        for (var p = 1; p <= 2; p += 1) {
          var surowy = warianty[w][p];
          var kod = surowy ? kodIdealny(surowy) : '';
          if (!kod) continue;
          if (!mapa[kod]) mapa[kod] = [];
          var juz = mapa[kod].some(function (t) { return t.wariant === warianty[w][0]; });
          if (!juz) mapa[kod].push({ rekord: rekordy[i], wariant: warianty[w][0], kod: surowy });
        }
      }
    }
    return mapa;
  }

  function loadIndex() {
    if (stanIndeksu) return stanIndeksu;

    var zapamietane = zPamieci();
    if (zapamietane && zapamietane.length) {
      stanIndeksu = Promise.resolve({ rekordy: zapamietane, mapa: zbudujMape(zapamietane), idealna: zbudujMapeIdealna(zapamietane) });
      return stanIndeksu;
    }

    stanIndeksu = pobierzStrone(1)
      .then(function (pierwsza) {
        var stron = Math.max(1, parseInt(pierwsza.s, 10) || 1);
        var dalsze = [];
        for (var n = 2; n <= stron; n += 1) dalsze.push(pobierzStrone(n));
        return Promise.all(dalsze).then(function (reszta) {
          var rekordy = pierwsza.r || [];
          for (var i = 0; i < reszta.length; i += 1) {
            rekordy = rekordy.concat(reszta[i].r || []);
          }
          return rekordy;
        });
      })
      .then(function (rekordy) {
        doPamieci(rekordy);
        return { rekordy: rekordy, mapa: zbudujMape(rekordy), idealna: zbudujMapeIdealna(rekordy) };
      })
      .catch(function (blad) {
        stanIndeksu = null;
        throw blad;
      });

    return stanIndeksu;
  }

  function find(zapytanie) {
    return loadIndex().then(function (indeks) {
      var kod = normalize(zapytanie);
      if (!kod) return [];
      return (indeks.mapa[kod] || []).slice();
    });
  }

  function suggest(zapytanie, ile) {
    var limit = ile || 5;
    return loadIndex().then(function (indeks) {
      var fragment = normalize(zapytanie);
      if (fragment.length < MIN_DLUGOSC_KODU) return [];
      var wynik = [];
      for (var i = 0; i < indeks.rekordy.length && wynik.length < limit; i += 1) {
        var rekord = indeks.rekordy[i];
        for (var k = 0; k < rekord.k.length; k += 1) {
          if (rekord.k[k].indexOf(fragment) !== -1) {
            wynik.push({ rekord: rekord, kod: rekord.c[k] || rekord.k[k] });
            break;
          }
        }
      }
      return wynik;
    });
  }

  var MIN_ZAWIERANIE = 5;

  function liczLitery(tekst) {
    var trafienia = String(tekst).match(/[A-Za-zÀ-ɏ]/g);
    return trafienia ? trafienia.length : 0;
  }

  function rozpoznaj(zapytanie) {
    var tekst = String(zapytanie || '').trim();
    if (!tekst) return null;
    if (isCodeQuery(tekst)) return 'numer';
    var cyfry = liczCyfry(tekst);
    var litery = liczLitery(tekst);
    if (cyfry > 0 && cyfry >= litery && normalize(tekst).length >= 3) return 'numer';
    if (litery > 0) return 'nazwa';
    return null;
  }

  function szukajNumeru(zapytanie, ile) {
    var limit = ile || 5;
    return loadIndex().then(function (indeks) {
      var fragment = normalize(zapytanie);
      if (!fragment) return { dokladne: [], podobne: [] };

      var dokladne = (indeks.mapa[fragment] || []).map(function (rekord) {
        return { rekord: rekord, kod: rekord.c[0] || fragment, dokladne: true };
      });

      var podobne = [];
      if (fragment.length >= 3) {
        for (var i = 0; i < indeks.rekordy.length && podobne.length < limit; i += 1) {
          var rekord = indeks.rekordy[i];
          var juz = false;
          for (var d = 0; d < dokladne.length; d += 1) {
            if (dokladne[d].rekord === rekord) juz = true;
          }
          if (juz) continue;
          for (var k = 0; k < rekord.k.length; k += 1) {
            var kod = rekord.k[k];
            var pasuje = kod.indexOf(fragment) !== -1
              || (fragment.length >= MIN_ZAWIERANIE && kod.length >= MIN_ZAWIERANIE && fragment.indexOf(kod) !== -1);
            if (pasuje) {
              podobne.push({ rekord: rekord, kod: rekord.c[k] || kod, dokladne: false });
              break;
            }
          }
        }
      }
      return { dokladne: dokladne, podobne: podobne };
    });
  }

  function szukajNazwy(zapytanie, ile) {
    var limit = ile || 5;
    return loadIndex().then(function (indeks) {
      var slowa = String(zapytanie).trim().split(/[\s ]+/).map(normalize).filter(Boolean);
      if (!slowa.length) return { dokladne: [], podobne: [] };
      var podobne = [];
      for (var i = 0; i < indeks.rekordy.length && podobne.length < limit; i += 1) {
        var rekord = indeks.rekordy[i];
        var stog = normalize(rekord.t) + normalize(rekord.m || '');
        var wszystkie = true;
        for (var s = 0; s < slowa.length; s += 1) {
          if (stog.indexOf(slowa[s]) === -1) { wszystkie = false; break; }
        }
        if (wszystkie) podobne.push({ rekord: rekord, kod: (rekord.c || [])[0] || '', dokladne: false });
      }
      return { dokladne: [], podobne: podobne };
    });
  }

  function szukaj(zapytanie, ile) {
    var typ = rozpoznaj(zapytanie);
    if (typ === 'numer') {
      return szukajNumeru(zapytanie, ile).then(function (w) { w.typ = typ; return w; });
    }
    if (typ === 'nazwa') {
      return szukajNazwy(zapytanie, ile).then(function (w) { w.typ = typ; return w; });
    }
    return Promise.resolve({ typ: null, dokladne: [], podobne: [] });
  }

  function szukajIdealnie(zapytanie) {
    return loadIndex().then(function (indeks) {
      var kod = kodIdealny(zapytanie);
      var trafienia = kod ? (indeks.idealna[kod] || []) : [];
      return {
        typ: 'idealne',
        dokladne: trafienia.map(function (t) {
          return { rekord: t.rekord, kod: t.kod, wariant: t.wariant, dokladne: true };
        }),
        podobne: []
      };
    });
  }

  window.BramoweHomeSearch = {
    normalize: normalize,
    kodIdealny: kodIdealny,
    szukajIdealnie: szukajIdealnie,
    isCodeQuery: isCodeQuery,
    rozpoznaj: rozpoznaj,
    loadIndex: loadIndex,
    find: find,
    suggest: suggest,
    szukaj: szukaj
  };

  var KLUCZ_ZAPYTANIA = 'bramowe-home-zapytanie';
  var MIN_ZNAKOW = 3;
  var ILE_WYNIKOW = 5;
  var ZWLOKA = 300;
  var ZWLOKA_ZERA = 600;
  var ZWLOKA_WSKAZNIKA = 150;

  function zdarzenie(nazwa, dane) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(nazwa, dane || {});
      }
    } catch (e) {}
  }

  function pusty(el) {
    while (el.firstChild) el.removeChild(el.firstChild);
  }

  function element(tag, klasa, tekst) {
    var el = document.createElement(tag);
    if (klasa) el.className = klasa;
    if (tekst !== undefined && tekst !== null) el.textContent = tekst;
    return el;
  }

  function Wyszukiwarka(korzen) {
    this.korzen = korzen;
    this.pole = korzen.querySelector('[data-bh-search-input]');
    this.wyniki = korzen.querySelector('[data-bh-search-results]');
    this.formularz = korzen.querySelector('form');
    this.opakowanieCzesci = korzen.querySelector('[data-bh-part-wrap]');
    this.okno = korzen.querySelector('[data-bh-help]');
    this.otwierajacy = korzen.querySelector('[data-bh-help-open]');
    this.przelacznik = korzen.querySelector('[data-bh-exact]');
    this.status = korzen.querySelector('[data-bh-search-status]');
    this.idealnie = !!this.przelacznik;

    this.teksty = {
      brak: korzen.getAttribute('data-msg-brak') || '',
      sprowadz: korzen.getAttribute('data-msg-sprowadz') || '',
      dokladne: korzen.getAttribute('data-msg-dokladne') || '',
      termin: korzen.getAttribute('data-label-termin') || '',
      produkt: korzen.getAttribute('data-label-produkt') || '',
      pokazPodobne: korzen.getAttribute('data-msg-pokaz-podobne') || '',
      licznik: korzen.getAttribute('data-msg-licznik') || ''
    };
    this.indeksZamowiony = false;
    this.uchwyty = [];
    this.zwloka = null;
    this.zwlokaZera = null;
    this.zwlokaWskaznika = null;
    this.numerZapytania = 0;
    this.wiersze = [];
    this.zaznaczony = -1;

    this.podlacz();
  }

  Wyszukiwarka.prototype.nasluch = function (cel, nazwa, funkcja) {
    cel.addEventListener(nazwa, funkcja);
    this.uchwyty.push([cel, nazwa, funkcja]);
  };

  Wyszukiwarka.prototype.rozlacz = function () {
    window.clearTimeout(this.zwloka);
    for (var i = 0; i < this.uchwyty.length; i += 1) {
      this.uchwyty[i][0].removeEventListener(this.uchwyty[i][1], this.uchwyty[i][2]);
    }
    this.uchwyty = [];
  };

  Wyszukiwarka.prototype.podlacz = function () {
    if (!this.pole || !this.formularz || !this.wyniki) return;
    var self = this;

    this.nasluch(this.pole, 'focus', function () { self.zamow(); });
    this.nasluch(this.pole, 'input', function () { self.przyPisaniu(); });
    this.nasluch(this.pole, 'keydown', function (ev) { self.przyKlawiszu(ev); });
    this.nasluch(this.formularz, 'submit', function (ev) { self.przyWyslaniu(ev); });

    if (this.okno && this.otwierajacy) {
      this.nasluch(this.otwierajacy, 'click', function () { self.otworzOkno(); });
      var zamykacz = this.okno.querySelector('[data-bh-help-close]');
      if (zamykacz) this.nasluch(zamykacz, 'click', function () { self.zamknijOkno(); });
      this.nasluch(this.okno, 'click', function (ev) {
        if (ev.target === self.okno) self.zamknijOkno();
      });
      this.nasluch(this.okno, 'close', function () {
        if (self.otwierajacy) self.otwierajacy.focus();
      });
    }

    var krotka = this.pole.getAttribute('data-placeholder-short');
    if (krotka && window.matchMedia) {
      var dluga = this.pole.getAttribute('placeholder');
      var waski = window.matchMedia('(max-width: 479px)');
      var ustawPodpowiedz = function () {
        self.pole.setAttribute('placeholder', waski.matches ? krotka : dluga);
      };
      ustawPodpowiedz();
      this.nasluch(waski, 'change', ustawPodpowiedz);
    }

    if (this.przelacznik) {
      this.nasluch(this.przelacznik, 'click', function () { self.ustawIdealnie(!self.idealnie); });
    }

    var zwijacz = this.korzen.querySelector('[data-bh-part-close]');
    if (zwijacz) this.nasluch(zwijacz, 'click', function () { self.schowajCzesci(); });

    this.przywrocZapytanie();
  };

  Wyszukiwarka.prototype.szukajWTrybie = function (zapytanie) {
    return this.idealnie ? szukajIdealnie(zapytanie) : szukaj(zapytanie, ILE_WYNIKOW);
  };

  Wyszukiwarka.prototype.ustawIdealnie = function (tak) {
    var self = this;
    this.idealnie = !!tak;
    if (this.przelacznik) this.przelacznik.setAttribute('aria-checked', this.idealnie ? 'true' : 'false');
    var zapytanie = this.pole.value;
    if (zapytanie.trim().length < MIN_ZNAKOW) return;
    this.nowyNumer();
    this.wykonaj(zapytanie, this.numerZapytania, true);
  };

  Wyszukiwarka.prototype.otworzOkno = function () {
    if (!this.okno) return;
    if (typeof this.okno.showModal === 'function') this.okno.showModal();
    else this.okno.setAttribute('open', '');
    var zamykacz = this.okno.querySelector('[data-bh-help-close]');
    if (zamykacz) zamykacz.focus();
  };

  Wyszukiwarka.prototype.zamknijOkno = function () {
    if (!this.okno) return;
    if (typeof this.okno.close === 'function') this.okno.close();
    else this.okno.removeAttribute('open');
  };

  Wyszukiwarka.prototype.zamow = function () {
    if (this.indeksZamowiony) return;
    this.indeksZamowiony = true;
    loadIndex().catch(function () {});
  };

  Wyszukiwarka.prototype.zapamietajZapytanie = function () {
    try { window.sessionStorage.setItem(KLUCZ_ZAPYTANIA, this.pole.value); } catch (e) {}
  };

  Wyszukiwarka.prototype.przywrocZapytanie = function () {
    var zapis = null;
    try { zapis = window.sessionStorage.getItem(KLUCZ_ZAPYTANIA); } catch (e) { zapis = null; }
    if (!zapis) return;
    this.pole.value = zapis;
    this.zamow();
    this.przyPisaniu();
  };

  Wyszukiwarka.prototype.ustawListe = function (otwarta) {
    this.pole.setAttribute('aria-expanded', otwarta ? 'true' : 'false');
    if (!otwarta) {
      this.pole.removeAttribute('aria-activedescendant');
      this.wiersze = [];
      this.zaznaczony = -1;
    }
  };

  Wyszukiwarka.prototype.karta = function (poz, indeks) {
    var rekord = poz.rekord;
    var kod = poz.kod;
    var self = this;

    var wiersz = element('a', 'bh-result');
    wiersz.href = poz.wariant ? rekord.u + (rekord.u.indexOf('?') === -1 ? '?' : '&') + 'variant=' + poz.wariant : rekord.u;
    wiersz.id = (this.pole.id || 'bh-wynik') + '-wynik-' + indeks;
    wiersz.setAttribute('role', 'option');
    wiersz.setAttribute('aria-selected', 'false');
    wiersz.addEventListener('click', function () {
      self.zapamietajZapytanie();
      zdarzenie('bramowe_home_search_pick', { pozycja: indeks + 1, dokladne: !!poz.dokladne });
    });

    if (rekord.i) {
      var media = element('span', 'bh-result__media');
      var img = document.createElement('img');
      img.className = 'bh-result__img';
      img.src = rekord.i;
      img.width = 48;
      img.height = 48;
      img.loading = 'lazy';
      img.alt = '';
      media.appendChild(img);
      wiersz.appendChild(media);
    }

    var tresc = element('span', 'bh-result__body');
    if (rekord.m) tresc.appendChild(element('span', 'bh-result__vendor', rekord.m));
    tresc.appendChild(element('span', 'bh-result__title', rekord.t));

    var meta = element('span', 'bh-result__meta');
    if (kod) meta.appendChild(element('span', 'bh-result__sku', kod));
    if (rekord.d) {
      var termin = element('span', 'bh-result__term', rekord.d);
      if (rekord.d === '24h') termin.className = 'bh-result__term bh-result__term--fast';
      meta.appendChild(termin);
    }
    tresc.appendChild(meta);
    wiersz.appendChild(tresc);

    var prawa = element('span', 'bh-result__side');
    if (poz.dokladne && this.teksty.dokladne) {
      prawa.appendChild(element('span', 'bh-badge bh-result__badge', this.teksty.dokladne));
    }
    if (rekord.p) prawa.appendChild(element('span', 'bh-price bh-result__price', rekord.p));
    wiersz.appendChild(prawa);

    return wiersz;
  };

  Wyszukiwarka.prototype.nowyNumer = function () {
    window.clearTimeout(this.zwloka);
    window.clearTimeout(this.zwlokaZera);
    this.numerZapytania += 1;
  };

  Wyszukiwarka.prototype.wToku = function (tak) {
    var self = this;
    window.clearTimeout(this.zwlokaWskaznika);
    if (tak) {
      this.zwlokaWskaznika = window.setTimeout(function () {
        self.korzen.classList.add('bh-finder--szuka');
      }, ZWLOKA_WSKAZNIKA);
    } else {
      this.korzen.classList.remove('bh-finder--szuka');
    }
  };

  Wyszukiwarka.prototype.przyPisaniu = function () {
    var self = this;
    var zapytanie = this.pole.value;
    this.zapamietajZapytanie();
    this.nowyNumer();

    if (zapytanie.trim().length < MIN_ZNAKOW) {
      this.wToku(false);
      this.wyczyscWyniki();
      return;
    }

    this.zamow();
    var numer = this.numerZapytania;
    this.zwloka = window.setTimeout(function () { self.wykonaj(zapytanie, numer, false); }, ZWLOKA);
  };

  Wyszukiwarka.prototype.wykonaj = function (zapytanie, numer, natychmiast) {
    var self = this;
    this.wToku(true);
    this.szukajWTrybie(zapytanie)
      .then(function (w) {
        if (numer !== self.numerZapytania) return;
        self.wToku(false);
        var ile = (w.dokladne || []).length + (w.podobne || []).length;
        if (ile || natychmiast) { self.pokazWyniki(w); return; }
        self.zwlokaZera = window.setTimeout(function () {
          if (numer === self.numerZapytania) self.pokazWyniki(w);
        }, ZWLOKA_ZERA);
      })
      .catch(function () {
        if (numer !== self.numerZapytania) return;
        self.wToku(false);
        self.wyczyscWyniki();
      });
  };

  Wyszukiwarka.prototype.wyczyscWyniki = function () {
    var self = this;
    if (this.status) this.status.textContent = '';
    if (!this.wyniki.firstChild) return;
    this.zmienPlynnie(function () {
      pusty(self.wyniki);
      self.ustawListe(false);
    });
  };

  Wyszukiwarka.prototype.pokazWyniki = function (w) {
    var self = this;
    var dokladne = w.dokladne || [];
    var podobne = (w.podobne || []).slice(0, Math.max(0, ILE_WYNIKOW - dokladne.length));
    var pozycje = dokladne.concat(podobne);
    var zapytanie = this.pole.value.trim();
    var zdanieBraku = this.teksty.brak.replace('[numer]', zapytanie.toLocaleUpperCase('pl-PL'));

    this.zmienPlynnie(function () {
      pusty(self.wyniki);
      self.wiersze = [];
      self.zaznaczony = -1;

      for (var i = 0; i < pozycje.length; i += 1) {
        var wiersz = self.karta(pozycje[i], i);
        self.wyniki.appendChild(wiersz);
        self.wiersze.push(wiersz);
      }

      if (!pozycje.length) self.wyniki.appendChild(self.blokZera(w, zapytanie, zdanieBraku));

      self.ustawListe(pozycje.length > 0);
      if (dokladne.length) self.wiersze[0].classList.add('bh-result--trafiony');
    });

    if (this.status) {
      this.status.textContent = pozycje.length
        ? this.teksty.licznik.replace('[n]', String(pozycje.length))
        : zdanieBraku;
    }

    zdarzenie('bramowe_home_search', { typ: w.typ || 'nieznany', trafien: pozycje.length });
  };

  Wyszukiwarka.prototype.blokZera = function (w, zapytanie, zdanie) {
    var self = this;
    var blok = element('div', 'bh-finder__zero');
    blok.appendChild(element('p', 'bh-finder__msg', zdanie));

    var akcje = element('div', 'bh-finder__actions');
    if (this.teksty.sprowadz) {
      var przycisk = element('button', 'bh-btn bh-btn--primary', this.teksty.sprowadz);
      przycisk.type = 'button';
      przycisk.addEventListener('click', function () { self.pokazCzesci(zapytanie); });
      akcje.appendChild(przycisk);
    }
    if (w.typ === 'idealne' && this.teksty.pokazPodobne) {
      var podobne = element('button', 'bh-finder__link', this.teksty.pokazPodobne);
      podobne.type = 'button';
      podobne.addEventListener('click', function () {
        self.ustawIdealnie(false);
        self.pole.focus({ preventScroll: true });
      });
      akcje.appendChild(podobne);
    }
    blok.appendChild(akcje);

    zdarzenie('bramowe_home_search_no_exact', {});
    return blok;
  };

  Wyszukiwarka.prototype.przyKlawiszu = function (ev) {
    if (ev.key === 'Escape') {
      this.wyczyscWyniki();
      return;
    }
    if (!this.wiersze.length) return;

    if (ev.key === 'ArrowDown' || ev.key === 'ArrowUp') {
      ev.preventDefault();
      var krok = ev.key === 'ArrowDown' ? 1 : -1;
      var ile = this.wiersze.length;
      this.zaznacz(((this.zaznaczony + krok) % ile + ile) % ile);
      return;
    }

    if (ev.key === 'Enter' && this.zaznaczony >= 0) {
      ev.preventDefault();
      this.zapamietajZapytanie();
      zdarzenie('bramowe_home_search_pick', { pozycja: this.zaznaczony + 1, dokladne: this.zaznaczony === 0 });
      window.location.href = this.wiersze[this.zaznaczony].href;
    }
  };

  Wyszukiwarka.prototype.zaznacz = function (indeks) {
    for (var i = 0; i < this.wiersze.length; i += 1) {
      var wybrany = i === indeks;
      this.wiersze[i].setAttribute('aria-selected', wybrany ? 'true' : 'false');
      this.wiersze[i].classList.toggle('bh-result--zaznaczony', wybrany);
    }
    this.zaznaczony = indeks;
    var cel = this.wiersze[indeks];
    if (cel) this.pole.setAttribute('aria-activedescendant', cel.id);
  };

  Wyszukiwarka.prototype.przyWyslaniu = function (ev) {
    var self = this;
    var zapytanie = this.pole.value.trim();
    if (!zapytanie) return;
    if (ev) ev.preventDefault();

    this.zamow();
    this.nowyNumer();

    if (this.idealnie) {
      var numer = this.numerZapytania;
      this.wToku(true);
      szukajIdealnie(zapytanie)
        .then(function (w) {
          if (numer !== self.numerZapytania) return;
          self.wToku(false);
          self.pokazWyniki(w);
        })
        .catch(function () { self.wToku(false); self.formularz.submit(); });
      return;
    }

    szukaj(zapytanie, ILE_WYNIKOW)
      .then(function (w) {
        if ((w.dokladne || []).length === 1) {
          self.zapamietajZapytanie();
          zdarzenie('bramowe_home_search_pick', { pozycja: 1, dokladne: true });
          window.location.href = w.dokladne[0].rekord.u;
          return;
        }
        self.pokazWyniki(w);
      })
      .catch(function () {
        self.formularz.submit();
      });
  };

  Wyszukiwarka.prototype.pojemnikModulu = function () {
    return this.korzen.closest ? this.korzen.closest('[data-bh-start]') : null;
  };

  Wyszukiwarka.prototype.zmienPlynnie = function (zmiana, poZmianie) {
    var api = window.BramoweHomeScroll;
    var pojemnik = this.pojemnikModulu();
    if (api && api.animujWysokosc && pojemnik) api.animujWysokosc(pojemnik, zmiana, poZmianie);
    else { zmiana(); if (poZmianie) poZmianie(); }
  };

  Wyszukiwarka.prototype.wypelnijCzesci = function (numer) {
    if (!this.opakowanieCzesci) return;
    this.opakowanieCzesci.hidden = false;

    var poleNumeru = this.opakowanieCzesci.querySelector('[data-bh-part-number]');
    if (poleNumeru) poleNumeru.value = numer;

    var whatsapp = this.opakowanieCzesci.querySelector('[data-bh-whatsapp]');
    if (whatsapp) {
      var baza = whatsapp.getAttribute('data-base') || '';
      whatsapp.href = numer ? baza + encodeURIComponent(numer) : baza;
    }
  };

  Wyszukiwarka.prototype.poRozwinieciuCzesci = function () {
    if (!this.opakowanieCzesci) return;
    var api = window.BramoweHomeScroll;
    if (api && !api.gornaWWidoku(this.opakowanieCzesci)) api.doCelu(this.opakowanieCzesci);

    var poleEmail = this.opakowanieCzesci.querySelector('[data-bh-part-email]');
    if (poleEmail) {
      try {
        poleEmail.focus({ preventScroll: true });
      } catch (e) {
        poleEmail.focus();
      }
    }
  };

  Wyszukiwarka.prototype.pokazCzesci = function (numer) {
    if (!this.opakowanieCzesci) return;
    var self = this;
    this.zmienPlynnie(
      function () { self.wypelnijCzesci(numer); },
      function () { self.poRozwinieciuCzesci(); },
    );
    zdarzenie('bramowe_home_part_request', {});
  };

  Wyszukiwarka.prototype.schowajCzesci = function () {
    if (!this.opakowanieCzesci) return;
    var self = this;
    this.zmienPlynnie(
      function () { self.opakowanieCzesci.hidden = true; },
      function () { if (self.pole) self.pole.focus({ preventScroll: true }); },
    );
  };

  var instancje = new WeakMap();

  function uruchom(zakres) {
    var korzenie = (zakres || document).querySelectorAll('[data-bh-search]');
    for (var i = 0; i < korzenie.length; i += 1) {
      if (instancje.has(korzenie[i])) continue;
      instancje.set(korzenie[i], new Wyszukiwarka(korzenie[i]));
    }
  }

  function zatrzymaj(zakres) {
    var korzenie = (zakres || document).querySelectorAll('[data-bh-search]');
    for (var i = 0; i < korzenie.length; i += 1) {
      var instancja = instancje.get(korzenie[i]);
      if (instancja) { instancja.rozlacz(); instancje.delete(korzenie[i]); }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { uruchom(); });
  } else {
    uruchom();
  }

  document.addEventListener('shopify:section:load', function (ev) { uruchom(ev.target); });
  document.addEventListener('shopify:section:unload', function (ev) { zatrzymaj(ev.target); });
}());
